import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

const useSigningLoader = (searchParamsKey: string) => {
  const [searchParams, setSearchParams] = useSearchParams()

  // Handlers
  const removeLoaderSearchParam = useCallback(() => {
    if (searchParams.has(searchParamsKey)) {
      searchParams.delete(searchParamsKey)
      setSearchParams(searchParams)
    }
  }, [searchParams, searchParamsKey, setSearchParams])

  const showSigningLoader = useMemo(() => searchParams.get(searchParamsKey) === 'true', [searchParams, searchParamsKey])

  return [showSigningLoader, removeLoaderSearchParam] as const
}

export { useSigningLoader }
